import { useMutation } from "@tanstack/react-query";
import { useOrderContext } from "app/providers/OrderProvider";
import { api } from "shared/api";
import { CreateOrderPaymentPayload } from "shared/api/middleware-api-client";
import { usePaymentContext } from "../../../pages/payment/providers/PaymentProvider";

export interface standardOrderPaymentLinkPayload {
  orderId: string;
  data: CreateOrderPaymentPayload;
}

export const useCreatePaymentLink = () => {
  const { order } = useOrderContext();

  const { standardProductOrder } = usePaymentContext();

  const createPaymentLink = async (payload: CreateOrderPaymentPayload) => {
    const res = await api().createOrderPayment(order!.id, payload);
    return res.data;
  };

  const createStandardOrderPaymentLink = async (
    payload: standardOrderPaymentLinkPayload,
  ) => {
    const res = await api().createStandardOrderPayment(
      payload.orderId,
      payload.data,
    );
    return res.data;
  };

  const {
    mutate: mutatePaymentLinkCreation,
    isLoading: isCreatePaymentLinkLoading,
  } = useMutation(createPaymentLink, {
    onSuccess: (data) => {
      window.location.href = data.paymentUrl;
    },
    onError: () => {
      // toast.error("Er is iets fout gegaan in het betaalproces.");
    },
  });

  const {
    mutate: mutateStandardOrderPaymentLinkCreation,
    isLoading: isCreateStandardOrderPaymentLinkLoading,
  } = useMutation(createStandardOrderPaymentLink, {
    onSuccess: (data) => {
      window.location.href = data.paymentUrl;
    },
    onError: () => {
      // toast.error("Er is iets fout gegaan in het betaalproces.");
    },
  });

  return {
    mutatePaymentLinkCreation,
    isCreatePaymentLinkLoading,
    mutateStandardOrderPaymentLinkCreation,
    isCreateStandardOrderPaymentLinkLoading,
  };
};
